import { Row, Col } from 'react-bootstrap';
import { formatGallons } from '../../dwriUtils';
import '../../dwri.css';

const DwriAverageAnnualDemandPerErc = ({ rows = [] }) => {

  return (
    <>
      <Row>
        <Col><span><b>Average Annual Demand Per ERC (Gal/year)</b></span></Col>
      </Row>

      <div className="table-responsive">
        <Row className="dwri-average-annual-demand-header gx-0">
          <Col className="dwri-table-header-cell dwri-col-year"><span><b>Year</b></span></Col>
          <Col className="dwri-table-header-cell"><span><b>Total from Sources (gal)</b></span></Col>
          <Col className="dwri-table-header-cell"><span><b>Total Wholesale Sources (gal)</b></span></Col>
          <Col className="dwri-table-header-cell"><span><b>Source Wholesale (gal)</b></span></Col>
          <Col className="dwri-table-header-cell"><span><b>Average Annual/ERC (gal)</b></span></Col>
          <Col className="dwri-table-header-cell"><span><b>Adjusted Avg Annual/ERC (gal)</b></span></Col>
          <Col className="dwri-table-header-cell"><span><b>Adjustment Justification</b></span></Col>
        </Row>

        {rows.map((row, index) => (
          <Row
            key={row.year ?? index}
            className={`dwri-average-annual-demand-row gx-0 ${index % 2 === 0 ? 'is-even' : 'is-odd'}`}
          >
            <Col className="dwri-table-cell dwri-col-year"><span>{row.year}</span></Col>
            <Col className="dwri-table-cell"><span>{formatGallons(row.totalFromSourcesGallons)}</span></Col>
            <Col className="dwri-table-cell"><span>{formatGallons(row.totalWholesaleSourcesGallons)}</span></Col>
            <Col className="dwri-table-cell"><span>{formatGallons(row.sourceLessWholesaleGallons)}</span></Col>
            <Col className="dwri-table-cell"><span>{formatGallons(row.averageAnnualDemandErc)}</span></Col>
            <Col className="dwri-table-cell"><span>{formatGallons(row.adjustedAverageAnnualDemandErc)}</span></Col>
            <Col className="dwri-table-cell"><span>{row.adjustmentJustification}</span></Col>
          </Row>
        ))}
      </div>
    </>
  );
};

export default DwriAverageAnnualDemandPerErc;
